// AUTO-GENERATED from '6 .Land Details Districtwise.xlsx' — DO NOT EDIT.
const LAND_PATTAS_DISTRICT = {
  "state": {
    "pattas_can_be_given": 508267,
    "pattas_given_beneficiaries": 491064,
    "vacant_plot": 56657,
    "total_applications": 5985,
    "eligible_not_given": 43775,
    "rejected_petitions": 659,
    "not_scrutinised": 764
  },
  "districts": {
    "ARIYALUR": {
      "pattas_can_be_given": 7926,
      "pattas_given_beneficiaries": 7611,
      "vacant_plot": 315,
      "total_applications": 57,
      "eligible_not_given": 41,
      "rejected_petitions": 16,
      "not_scrutinised": 0
    },
    "CHENGALPATTU": {
      "pattas_can_be_given": 4259,
      "pattas_given_beneficiaries": 4259,
      "vacant_plot": null,
      "total_applications": null,
      "eligible_not_given": 0,
      "rejected_petitions": null,
      "not_scrutinised": null
    },
    "CHENNAI": {
      "pattas_can_be_given": 21743,
      "pattas_given_beneficiaries": 20820,
      "vacant_plot": 228,
      "total_applications": 848,
      "eligible_not_given": 560,
      "rejected_petitions": 70,
      "not_scrutinised": null
    },
    "COIMBATORE": {
      "pattas_can_be_given": 16295,
      "pattas_given_beneficiaries": 15862,
      "vacant_plot": 778,
      "total_applications": 91,
      "eligible_not_given": 317,
      "rejected_petitions": null,
      "not_scrutinised": null
    },
    "CUDDALORE": {
      "pattas_can_be_given": 16952,
      "pattas_given_beneficiaries": 13598,
      "vacant_plot": 2657,
      "total_applications": 450,
      "eligible_not_given": 3354,
      "rejected_petitions": 94,
      "not_scrutinised": 356
    },
    "DHARMAPURI": {
      "pattas_can_be_given": 45708,
      "pattas_given_beneficiaries": 45708,
      "vacant_plot": 132,
      "total_applications": null,
      "eligible_not_given": 10065,
      "rejected_petitions": null,
      "not_scrutinised": null
    },
    "DINDIGUL": {
      "pattas_can_be_given": 12962,
      "pattas_given_beneficiaries": 12962,
      "vacant_plot": 0,
      "total_applications": null,
      "eligible_not_given": 4872,
      "rejected_petitions": null,
      "not_scrutinised": null
    },
    "ERODE": {
      "pattas_can_be_given": 23282,
      "pattas_given_beneficiaries": 23282,
      "vacant_plot": 2449,
      "total_applications": null,
      "eligible_not_given": 0,
      "rejected_petitions": null,
      "not_scrutinised": null
    },
    "KALLAKURICHI": {
      "pattas_can_be_given": 4661,
      "pattas_given_beneficiaries": 1097,
      "vacant_plot": 1243,
      "total_applications": null,
      "eligible_not_given": 1993,
      "rejected_petitions": null,
      "not_scrutinised": null
    },
    "KANCHEEPURAM": {
      "pattas_can_be_given": 6680,
      "pattas_given_beneficiaries": 6243,
      "vacant_plot": 373,
      "total_applications": null,
      "eligible_not_given": 373,
      "rejected_petitions": null,
      "not_scrutinised": null
    },
    "KANNIYAKUMARI": {
      "pattas_can_be_given": 17920,
      "pattas_given_beneficiaries": 15098,
      "vacant_plot": 2822,
      "total_applications": 810,
      "eligible_not_given": 810,
      "rejected_petitions": 0,
      "not_scrutinised": 0
    },
    "KARUR": {
      "pattas_can_be_given": 15255,
      "pattas_given_beneficiaries": 12028,
      "vacant_plot": 556,
      "total_applications": null,
      "eligible_not_given": 3227,
      "rejected_petitions": null,
      "not_scrutinised": null
    },
    "KRISHNAGIRI": {
      "pattas_can_be_given": 16035,
      "pattas_given_beneficiaries": 13815,
      "vacant_plot": 2465,
      "total_applications": null,
      "eligible_not_given": 2220,
      "rejected_petitions": null,
      "not_scrutinised": null
    },
    "MADURAI": {
      "pattas_can_be_given": 2822,
      "pattas_given_beneficiaries": 2799,
      "vacant_plot": 106,
      "total_applications": null,
      "eligible_not_given": 23,
      "rejected_petitions": null,
      "not_scrutinised": null
    },
    "MAYILADUTHURAI": {
      "pattas_can_be_given": 2922,
      "pattas_given_beneficiaries": 2761,
      "vacant_plot": 161,
      "total_applications": 116,
      "eligible_not_given": 116,
      "rejected_petitions": 0,
      "not_scrutinised": 0
    },
    "NAGAPATTINAM": {
      "pattas_can_be_given": 14674,
      "pattas_given_beneficiaries": 14496,
      "vacant_plot": 178,
      "total_applications": 520,
      "eligible_not_given": 178,
      "rejected_petitions": 195,
      "not_scrutinised": 147
    },
    "NAMAKKAL": {
      "pattas_can_be_given": 3252,
      "pattas_given_beneficiaries": 3102,
      "vacant_plot": 150,
      "total_applications": null,
      "eligible_not_given": 0,
      "rejected_petitions": null,
      "not_scrutinised": null
    },
    "PERAMBALUR": {
      "pattas_can_be_given": 10055,
      "pattas_given_beneficiaries": 9873,
      "vacant_plot": 859,
      "total_applications": null,
      "eligible_not_given": 182,
      "rejected_petitions": null,
      "not_scrutinised": null
    },
    "PUDUKKOTTAI": {
      "pattas_can_be_given": 9830,
      "pattas_given_beneficiaries": 9479,
      "vacant_plot": 351,
      "total_applications": 223,
      "eligible_not_given": 173,
      "rejected_petitions": 29,
      "not_scrutinised": 21
    },
    "RAMANATHAPURAM": {
      "pattas_can_be_given": 12175,
      "pattas_given_beneficiaries": 12175,
      "vacant_plot": 4184,
      "total_applications": null,
      "eligible_not_given": 0,
      "rejected_petitions": null,
      "not_scrutinised": null
    },
    "RANIPET": {
      "pattas_can_be_given": 12652,
      "pattas_given_beneficiaries": 5150,
      "vacant_plot": 7502,
      "total_applications": 72,
      "eligible_not_given": 72,
      "rejected_petitions": 0,
      "not_scrutinised": 0
    },
    "SALEM": {
      "pattas_can_be_given": 11334,
      "pattas_given_beneficiaries": 11334,
      "vacant_plot": 2440,
      "total_applications": null,
      "eligible_not_given": 0,
      "rejected_petitions": null,
      "not_scrutinised": null
    },
    "SIVAGANGAI": {
      "pattas_can_be_given": 10738,
      "pattas_given_beneficiaries": 9192,
      "vacant_plot": 1546,
      "total_applications": 372,
      "eligible_not_given": 352,
      "rejected_petitions": 20,
      "not_scrutinised": 0
    },
    "TENKASI": {
      "pattas_can_be_given": 13006,
      "pattas_given_beneficiaries": 7762,
      "vacant_plot": 1692,
      "total_applications": null,
      "eligible_not_given": 145,
      "rejected_petitions": null,
      "not_scrutinised": null
    },
    "THANJAVUR": {
      "pattas_can_be_given": 9947,
      "pattas_given_beneficiaries": 9947,
      "vacant_plot": 838,
      "total_applications": null,
      "eligible_not_given": 1482,
      "rejected_petitions": null,
      "not_scrutinised": null
    },
    "THE NILGIRIS": {
      "pattas_can_be_given": 17323,
      "pattas_given_beneficiaries": 11680,
      "vacant_plot": 1412,
      "total_applications": null,
      "eligible_not_given": 5643,
      "rejected_petitions": null,
      "not_scrutinised": null
    },
    "THENI": {
      "pattas_can_be_given": 22347,
      "pattas_given_beneficiaries": 22347,
      "vacant_plot": 0,
      "total_applications": 108,
      "eligible_not_given": 64,
      "rejected_petitions": 44,
      "not_scrutinised": 64
    },
    "THOOTHUKKUDI": {
      "pattas_can_be_given": 12058,
      "pattas_given_beneficiaries": 10452,
      "vacant_plot": 1606,
      "total_applications": 1136,
      "eligible_not_given": 1003,
      "rejected_petitions": 21,
      "not_scrutinised": 112
    },
    "TIRUCHIRAPPALLI": {
      "pattas_can_be_given": 210,
      "pattas_given_beneficiaries": 25219,
      "vacant_plot": 210,
      "total_applications": null,
      "eligible_not_given": 210,
      "rejected_petitions": null,
      "not_scrutinised": null
    },
    "TIRUNELVELI": {
      "pattas_can_be_given": 11153,
      "pattas_given_beneficiaries": 11153,
      "vacant_plot": 0,
      "total_applications": 265,
      "eligible_not_given": 79,
      "rejected_petitions": 78,
      "not_scrutinised": 0
    },
    "TIRUPATHUR": {
      "pattas_can_be_given": 11975,
      "pattas_given_beneficiaries": 11886,
      "vacant_plot": 89,
      "total_applications": null,
      "eligible_not_given": 89,
      "rejected_petitions": null,
      "not_scrutinised": null
    },
    "TIRUPPUR": {
      "pattas_can_be_given": 28854,
      "pattas_given_beneficiaries": 28830,
      "vacant_plot": 21,
      "total_applications": 531,
      "eligible_not_given": 223,
      "rejected_petitions": 37,
      "not_scrutinised": 0
    },
    "TIRUVALLUR": {
      "pattas_can_be_given": 16721,
      "pattas_given_beneficiaries": 16252,
      "vacant_plot": 0,
      "total_applications": null,
      "eligible_not_given": 469,
      "rejected_petitions": null,
      "not_scrutinised": null
    },
    "TIRUVANNAMALAI": {
      "pattas_can_be_given": 7394,
      "pattas_given_beneficiaries": 6764,
      "vacant_plot": 630,
      "total_applications": 219,
      "eligible_not_given": 133,
      "rejected_petitions": 39,
      "not_scrutinised": 47
    },
    "TIRUVARUR": {
      "pattas_can_be_given": 12747,
      "pattas_given_beneficiaries": 12747,
      "vacant_plot": 4881,
      "total_applications": null,
      "eligible_not_given": 4881,
      "rejected_petitions": null,
      "not_scrutinised": null
    },
    "VELLORE": {
      "pattas_can_be_given": 18773,
      "pattas_given_beneficiaries": 17926,
      "vacant_plot": 6385,
      "total_applications": 153,
      "eligible_not_given": 138,
      "rejected_petitions": null,
      "not_scrutinised": null
    },
    "VILLUPURAM": {
      "pattas_can_be_given": 25616,
      "pattas_given_beneficiaries": 25343,
      "vacant_plot": 7398,
      "total_applications": null,
      "eligible_not_given": 273,
      "rejected_petitions": null,
      "not_scrutinised": null
    }
  }
};

export default LAND_PATTAS_DISTRICT;
